// Shared site-wide constants for Reformity Inc.

export const COMPANY = {
    name: "Reformity Inc.",
    phone: "437-241-6287",
    phoneHref: "tel:4372416287",
    email: "info@reformityinc.com",
    emailHref: "mailto:info@reformityinc.com",
    // Public-facing location only. The full head-office address lives in
    // BUSINESS_ADDRESS (seo-constants) — it feeds the LocalBusiness JSON-LD and
    // the Privacy Policy contact block, but is deliberately not shown in the
    // footer/contact cards (owner directive predates the 2026 relocation;
    // revisit if full NAP in the footer is wanted for local SEO).
    address: "North York, Ontario",
    hours: "Mon–Sat: 8:00 AM – 6:00 PM, Sun: Closed",
    tagline: "GTA's trusted exterior & interior contracting specialists.",
    yearFounded: 2018, // reconciled to match LocalBusiness JSON-LD foundingDate + About copy (was 2026)
};

export const SERVICES = [
    { label: "Fencing", path: "/services/fencing" },
    { label: "Interlocking & Paving", path: "/services/interlocking" },
    { label: "Decking", path: "/services/decking" },
    { label: "Concrete & Asphalt", path: "/services/concrete" },
    { label: "Landscaping", path: "/services/landscaping" },
    { label: "Interior Renovations", path: "/services/renovations" },
];

export const NAV_LINKS = [
    { label: "Gallery", path: "/gallery" },
    { label: "Blog", path: "/blog" },
    { label: "About", path: "/about" },
    { label: "Service Area", path: "/service-area" },
    { label: "Contact", path: "/contact" },
];

export const SOCIAL_LINKS = [
    { label: "Facebook", href: "#", icon: "Facebook" },
    { label: "Instagram", href: "#", icon: "Instagram" },
    { label: "YouTube", href: "#", icon: "Youtube" },
];
